<template>
  <MainSoftForm>
    <!--Start form body    ------------------------------------------------------------------>
    <template v-slot:body>
      <!--Start form wrapper for catch errors  ------------------------>
      <FormGenerator
        lg="6"
        class="pt-4"
        :schema="schema"
        :validator="$v"
        :enter="submit"
      ></FormGenerator>
      <!--End   form wrapper for catch errors  ------------------------>
    </template>
    <!--End   form body    ------------------------------------------------------------------>

    <!--Start form actions ------------------------------------------------------------------>
    <template v-slot:action>
      <v-col cols="12" md="12" class="pt-0">
        <v-btn
          color="primary"
          :loading="is_loading"
          block
          @click="submit"
          :disabled="is_loading || $v.$error"
        >
          {{ $_t("attribute.reset_password") }}
        </v-btn>
      </v-col>
    </template>
    <!--End   form actions ------------------------------------------------------------------>
  </MainSoftForm>
</template>

<script>
import MainSoftForm from "@/components/app/form/MainSoftForm";
import FormGenerator from "@/components/app/form/MyFormGenerator";
import { mapGetters } from "vuex";
import { RESET_PASS } from "@/packages/dashboard/schema/RESET_PASSWORD_SCHEMA";
import message from "@/tools/Message";
export default {
  name: "ResetPasswordForm",
  components: { FormGenerator, MainSoftForm },
  computed: {
    ...mapGetters({
      is_loading: "loading/is_loading",
    }),
  },
  data: () => ({
    form: RESET_PASS.model,
    schema: RESET_PASS.schema,
  }),
  validations: {
    ...RESET_PASS.validations,
  },
  methods: {
    async submit() {
      try {
        if (!this.isFormValidate()) return;
        const res = await this.$actions.changePassword({
          oldPassword: this.form.olPassword,
          newPassword: this.form.newPassword,
        });
        console.log(res);
        if (res.data) message.success(this.$_t("PASSWORD_CHANGE_SUCCESS"));
        this.form.newPassword = null;
        this.form.olPassword = null;
        this.form.confirm_password = null;
        this.$v.$reset();
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style scoped></style>
